import queryString from 'query-string'
import * as R from 'ramda'
import {getAxios} from '../../axiosWithToken'

export const getNotPaidParticipants = () =>
    getAxios().get('participants/?is_paid=false')

export const getPaidParticipants = () =>
    getAxios().get('participants/?is_paid=true')

export const getParticipants = queryParams =>
    getAxios().get(`participants/?${queryString.stringify(queryParams)}`)

export const shouldShowConfirmPayment = raceId =>
    getParticipants().then(res => {
        const data = res.data
        return (
            data.filter(
                each => R.path(['race_detail', 'race', 'id'], each) === parseInt(raceId)
            ).length >= 1
        )
    })

export const getMyRun = () =>
    getAxios().get('participants/my-runs/?ordering=-created')
export const getRunByTime = queryParams =>
    getAxios().get(
        `participants/runs/?ordering=time&status=approve&${queryString.stringify(
            queryParams
        )}`
    )

export const getRanking = queryParams =>
    getAxios().get(`participants/ranking/?&${queryString.stringify(queryParams)}`)

export const getMyRanking = queryParams =>
    getAxios().get(
        `participants/my-ranking/?&${queryString.stringify(queryParams)}`
    )

export const firePixel = participant =>
    getAxios().get(`participants/fire-pixel/${participant.id}/`)

export const getDistance = raceId =>
    getAxios().get(
        `participants/distance/?race=${raceId}`
    )



// WEBPACK FOOTER //
// /opt/build/repo/src/api/async/participants/index.js